import { useQuery } from 'react-query';

import { MatterKimThreadResponseDto } from '../../../../backend/src/matter/subset/kim/dto/matter-thread.dto';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import { useFetcher } from '@/api/useGetFetchConfig';

export const useGetMatterKimThreads = (matterId?: string, subsetId?: string, enabled = true) => {
  const fetcher = useFetcher();

  return useQuery<MatterKimThreadResponseDto[], ApiError>(
    [QueryEntity.MatterKimThreads, { matterId }],
    () => fetcher(`${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/kim/matter-threads`),
    {
      enabled: enabled && !!matterId && !!subsetId,
      refetchOnWindowFocus: false,
    },
  );
};
